import { render, staticRenderFns } from "./CollectRecipientPhotoModal.vue?vue&type=template&id=4959d803&lang=pug"
import script from "./CollectRecipientPhotoModal.vue?vue&type=script&lang=js"
export * from "./CollectRecipientPhotoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports